import { useMutation, useQueryClient } from '@tanstack/react-query';

import { convertContractToDraft } from '../../../common/api/clients/contracts.api';
import { queries } from '../../../common/api/queryKeys/queries';

export const useContractConvertToDraft = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: convertContractToDraft,
        onSuccess: () => queryClient.invalidateQueries({ queryKey: queries.contracts._def }),
    });
};
